import React from "react";
import { Label } from "@jsq/ds/core";
import { FormTextInput, FormDatePicker } from "@jsq/ds/forms";
import { individualTypeOptions } from "#utils/account_types";
import { isBeforeProvidedDate } from "#utils/filter_date";
import { AccountTypeDropdown } from "../common/AccountTypeDropdown";
import { FieldGroup } from "../common/FieldGroup";
import { MultiInputFormRow } from "../common/MultiInputFormRow";
import { SimpleFormRow } from "../common/SimpleFormRow";
import { TaxIdInput } from "../TaxIdInput";
import { type IndividualInformationInputProps } from "./types";

export const IndividualInformationInput: React.FC<IndividualInformationInputProps> = ({
  title,
  description,
  meta,
  profileName,
  showAccountTypeDropdown = true,
}: IndividualInformationInputProps) => {
  const displayTitle = profileName ? `${profileName} ${title ?? ""}`.trim() : title;

  return (
    <FieldGroup title={displayTitle} description={description} meta={meta}>
      {showAccountTypeDropdown && (
        <SimpleFormRow>
          <AccountTypeDropdown
            name="accountType"
            accountTypes={individualTypeOptions}
            placeholder="Select individual type"
            label="Individual type"
          />
        </SimpleFormRow>
      )}
      <MultiInputFormRow>
        <FormTextInput
          key="firstName"
          data-testid="firstName"
          name="firstName"
          label="Name"
          placeholder="First"
          isFullWidth
        />
        <FormTextInput
          key="middleName"
          data-testid="middleName"
          name="middleName"
          label=" "
          placeholder="Middle"
          isFullWidth
        />
        <FormTextInput
          key="lastName"
          data-testid="lastName"
          name="lastName"
          label=" "
          placeholder="Last"
          isFullWidth
        />
      </MultiInputFormRow>
      <MultiInputFormRow>
        <>
          <Label htmlFor="dateOfBirth">Date of birth</Label>
          <FormDatePicker
            key="dateOfBirth"
            id="dateOfBirth"
            name="dateOfBirth"
            data-testid="dateOfBirth"
            isFull
            showMonthDropdown
            showYearDropdown
            yearDropdownItemNumber={125}
            maxDate={new Date()}
            placeholderText="MM/DD/YYYY"
            hasIcon
            data-cy="dateOfBirth"
            filterDate={isBeforeProvidedDate}
          />
        </>
        <TaxIdInput
          label="Identification number"
          description="Please provide a Taxpayer Identification Number (TIN). If your jurisdiction does not issue TINs (e.g., BVI, Cayman, Bermuda), enter your Passport ID, Drivers License number or equivalent Official Identifier."
        />
      </MultiInputFormRow>
    </FieldGroup>
  );
};
